export function FooterSection() {
  return (
    <footer className="bg-white">
      <div className="section-container pb-10 pt-0">
        <div className="flex flex-col items-center justify-between gap-4 border-t border-slate-200 pt-8 sm:flex-row">
          <p className="text-sm text-slate-400">
            &copy; 2026 Mind Mirth &middot; Irving, TX 75063
          </p>
          <p className="text-sm text-slate-400">
            Questions?{' '}
            <a
              href="tel:+19493002265"
              className="font-semibold text-slate-700 transition-colors hover:text-brand-600"
            >
              Text or call (949) 300-2265
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}